(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dclare-pdp-matching-set"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dclare-matching-set')) {
    customElements.define('dclare-matching-set', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        const dataNode = this.querySelector('[data-set-data]');
        if (!dataNode) return;
        this.initialized = true;
        this.data = JSON.parse(dataNode.textContent);
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.selectedSize = '';
        this.colour = null;
        this.pending = false;
        this.added = false;
        this.uncertain = false;
        this.addButton = this.querySelector('[data-set-add]');
        this.status = this.querySelector('[data-set-status]');
        this.cartLink = this.querySelector('[data-set-cart-link]');
        this.querySelectorAll('[data-set-size]').forEach(button => button.addEventListener('click', () => {
          this.selectedSize = button.dataset.setSize;
          this.added = false;
          this.status.textContent = '';
          this.render();
        }, {signal}));
        this.addButton.addEventListener('click', () => this.addToCart(), {signal});
        document.addEventListener('change', event => {
          if (this.contains(event.target)) return;
          if (event.target.closest('.product-column-right .option-selector')) queueMicrotask(() => this.syncColour());
        }, {signal});
        document.addEventListener('shopify:section:load', () => this.syncColour(), {signal});
        window.addEventListener('pageshow', () => this.syncColour(), {signal});
        this.syncColour();
      }
      disconnectedCallback() {
        queueMicrotask(() => {
          if (!this.isConnected) { this.controller?.abort(); this.initialized = false; }
        });
      }
      syncColour() {
        const picker = document.querySelector('.product-column-right .dclare-pdp-colour-selector');
        const checked = picker?.querySelector('input:checked');
        const colour = checked?.value || picker?.querySelector('select')?.value || this.data.initialColour || '';
        if (colour === this.colour) return;
        this.colour = colour;
        this.selectedSize = '';
        this.added = false;
        if (!this.uncertain) { this.status.textContent = ''; this.cartLink.hidden = true; }
        this.render();
      }
      render() {
        const sameColour = this.data.variants.filter(variant => this.data.colourIndex < 0 || String(variant.options[this.data.colourIndex]).toLowerCase() === String(this.colour).toLowerCase());
        const selected = sameColour.find(variant => this.data.sizeIndex < 0 || variant.options[this.data.sizeIndex] === this.selectedSize);
        this.selectedVariant = selected?.available ? selected : null;
        const display = selected || sameColour.find(variant => variant.available) || sameColour[0];
        const image = this.querySelector('.dclare-matching-set__image');
        if (image) {
          const source = display?.image || sameColour.find(variant => variant.image)?.image || this.data.fallbackImage;
          image.removeAttribute('srcset');
          if (image.getAttribute('src') !== source) image.src = source;
        }
        this.querySelector('[data-set-price]').textContent = display?.price || this.data.variants[0]?.price || '';
        const colourLabel = this.querySelector('[data-set-colour]');
        colourLabel.textContent = this.colour;
        colourLabel.hidden = !this.colour;
        this.querySelector('[data-set-product-link]').href = this.data.url + (display ? '?variant=' + display.id : '');
        const hasStock = sameColour.some(variant => variant.available);
        this.querySelector('[data-set-availability]').textContent = this.data.labels.unavailable;
        this.querySelector('[data-set-availability]').hidden = hasStock;
        this.querySelectorAll('[data-set-size]').forEach(button => {
          const available = sameColour.some(variant => variant.available && variant.options[this.data.sizeIndex] === button.dataset.setSize);
          button.disabled = this.pending || !available;
          button.setAttribute('aria-pressed', String(button.dataset.setSize === this.selectedSize));
          button.setAttribute('aria-label', button.dataset.setSize + (available ? '' : ' — ' + this.data.labels.soldOut));
        });
        this.addButton.disabled = this.pending || this.uncertain || this.added || !this.selectedVariant;
        this.addButton.textContent = this.pending ? this.data.labels.adding : this.added ? this.data.labels.added : !hasStock ? this.data.labels.soldOut : this.data.labels.add;
        this.addButton.setAttribute('aria-busy', String(this.pending));
      }
      async addToCart() {
        if (this.pending || this.uncertain || this.added || !this.selectedVariant) return;
        const variant = this.selectedVariant;
        this.pending = true;
        this.status.textContent = '';
        this.render();
        let confirmed = false;
        try {
          const response = await fetch(this.data.addUrl, {
            method:'POST', credentials:'same-origin',
            headers:{'Content-Type':'application/json',Accept:'application/json'},
            body:JSON.stringify({items:[{id:variant.id,quantity:1}]})
          });
          let result;
          try { result = await response.json(); } catch (_) { throw new Error('uncertain'); }
          if (!response.ok) {
            this.status.textContent = result.description || result.message || this.data.labels.error;
            if (response.status === 422) { variant.available = false; this.selectedSize = ''; }
            return;
          }
          confirmed = true;
          this.added = true;
          this.status.textContent = this.data.title + ' · ' + variant.options.join(' / ') + ' — ' + this.data.labels.added;
          this.cartLink.hidden = false;
          document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged',{bubbles:true}));
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          try {
            const cartResponse = await fetch(this.data.cartUrl,{credentials:'same-origin',headers:{Accept:'application/json'}});
            if (cartResponse.ok) document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart:await cartResponse.json()}}));
          } catch (_) {}
        } catch (_) {
          if (!confirmed) { this.uncertain = true; this.status.textContent = this.data.labels.uncertain; this.cartLink.hidden = false; }
        } finally {
          this.pending = false;
          this.render();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dclare-styled-look"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dclare-styled-look')) {
  customElements.define('dclare-styled-look', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.labels = JSON.parse(this.querySelector('[data-look-labels]').content.textContent);
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.querySelectorAll('[data-look-item]').forEach(item => this.setupItem(item, signal));
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(e => e.isIntersecting) && !this.viewed) this.viewed = this.track('styled_look_view');
      }, {threshold:.25});
      this.observer.observe(this);
      document.addEventListener('visitorConsentCollected', () => {
        const r = this.getBoundingClientRect();
        if (!this.viewed && r.bottom > 0 && r.top < innerHeight) this.viewed = this.track('styled_look_view');
      }, {signal});
      this.closest('details')?.addEventListener('toggle', () => {
        if (!this.closest('details').open && this.active) this.close(this.active, false);
      }, {signal});
    }
    disconnectedCallback() {
      this.observer?.disconnect(); this.abort?.abort();
      if (this.active) this.close(this.active);
      this.ready = false;
    }
    track(name, state, variant) {
      try {
        if (!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() || !window.Shopify?.analytics?.publish) return false;
        Promise.resolve(window.Shopify.analytics.publish(name, {
          current_product_id:this.dataset.product, complementary_product_id:state?.data.id || null,
          variant_id:variant?.id || null, look_id:this.dataset.look
        })).catch(() => {});
        return true;
      } catch (_) { return false; }
    }
    setupItem(item, signal) {
      const data = JSON.parse(item.querySelector('[data-look-product]').textContent);
      const state = {item, data, dialog:item.querySelector('.dc-look__panel'), trigger:this.querySelector('[aria-controls="'+item.querySelector('.dc-look__panel').id+'"]'), selected:[], pending:false, added:false, uncertain:false};
      const preferred = data.variants.find(v => String(v.id) === String(data.preferred));
      const colourNames = (this.dataset.colourNames || 'color,colour').toLowerCase().split(',').map(s => s.trim());
      state.colourIndex = data.options.findIndex(o => colourNames.includes(o.name.toLowerCase()));
      const host = item.querySelector('[data-look-options]');
      host.replaceChildren();
      data.options.forEach((option, index) => {
        const values = [...new Set(data.variants.map(v => v.options[index]))];
        if (index === state.colourIndex && preferred) {
          state.selected[index] = preferred.options[index];
          const line = document.createElement('p'); line.className = 'dc-look__colour'; line.textContent = option.name + ': ' + state.selected[index]; host.append(line); return;
        }
        if (data.defaultOnly) { state.selected[index] = values[0]; return; }
        const fieldset = document.createElement('fieldset');
        const legend = document.createElement('legend'); legend.textContent = option.name;
        const group = document.createElement('div'); group.className = 'dc-look__values';
        values.forEach(value => {
          const label = document.createElement('label'); label.className = 'dc-look__value';
          const input = document.createElement('input'); input.type = 'radio'; input.name = state.dialog.id + '-' + index; input.value = value; input.dataset.option = index;
          const text = document.createElement('span'); text.textContent = value;
          input.addEventListener('change', () => {
            state.selected[index] = value; state.added = false;
            if (index === state.colourIndex) data.options.forEach((o,i) => { if (i !== index) state.selected[i] = undefined; });
            this.render(state); this.track('styled_look_variant_select', state, state.variant);
          }, {signal});
          label.append(input,text); group.append(label);
        });
        fieldset.append(legend,group); host.append(fieldset);
      });
      state.trigger.addEventListener('click', () => {
        if (this.active === state) { this.close(state); return; }
        if (this.active) this.close(this.active, false);
        this.active = state; state.dialog.hidden = false;
        state.trigger.setAttribute('aria-expanded','true');
        this.render(state);
        state.dialog.querySelector('[data-look-close]').focus({preventScroll:true});
        state.dialog.scrollIntoView?.({block:'nearest',behavior:'auto'});
        this.track('styled_look_hotspot_click',state); this.track('styled_look_product_open',state);
      }, {signal});
      item.querySelector('[data-look-close]').addEventListener('click', () => this.close(state), {signal});
      state.dialog.addEventListener('keydown', e => { if (e.key === 'Escape') { e.preventDefault(); this.close(state); } }, {signal});
      item.querySelector('form').addEventListener('submit', e => {e.preventDefault(); this.add(state);}, {signal});
      item.querySelector('[data-look-link]').addEventListener('click', () => this.track('styled_look_view_product',state,state.variant), {signal});
      this.render(state);
    }
    close(state, restoreFocus = true) {
      state.dialog.hidden = true; state.trigger.setAttribute('aria-expanded','false');
      if (restoreFocus) state.trigger.focus({preventScroll:true});
      if (this.active === state) this.active = null;
    }
    render(state) {
      const {data,item} = state;
      state.variant = data.variants.find(v => v.available && data.options.every((_,i) => v.options[i] === state.selected[i]));
      item.querySelectorAll('input[data-option]').forEach(input => {
        const index = Number(input.dataset.option);
        input.checked = state.selected[index] === input.value;
        input.disabled = state.pending || !data.variants.some(v => v.available && v.options[index] === input.value && data.options.every((_,i) => i === index || !state.selected[i] || v.options[i] === state.selected[i]));
        input.setAttribute('aria-label',input.value + (input.disabled && !state.pending ? ' — ' + this.labels.sold_out : ''));
      });
      const available = data.variants.some(v => v.available && (state.colourIndex < 0 || !state.selected[state.colourIndex] || v.options[state.colourIndex] === state.selected[state.colourIndex]));
      const button = item.querySelector('[data-look-add]');
      button.disabled = state.pending || state.uncertain || state.added || !state.variant || data.requiresSellingPlan;
      button.textContent = state.pending ? this.labels.adding : state.added ? this.labels.added : !available ? this.labels.sold_out : state.variant ? this.labels.add : this.labels.choose;
      button.setAttribute('aria-busy',String(state.pending));
      const display = state.variant || data.variants.find(v => data.options.every((_,i) => !state.selected[i] || v.options[i] === state.selected[i]));
      if (display) {
        item.querySelector('[data-look-price]').textContent = display.money;
        
      }
      const link = item.querySelector('[data-look-link]'); link.href = data.url + (state.variant ? '?variant='+state.variant.id : '');
    }
    async add(state) {
      if (state.pending || state.uncertain || state.added || !state.variant || state.data.requiresSellingPlan) return;
      const variant = state.variant;
      state.pending = true; state.item.querySelector('[data-look-status]').textContent = ''; this.render(state);
      let confirmed = false;
      try {
        const response = await fetch(this.dataset.addUrl,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:variant.id,quantity:1}]})});
        const result = await response.json();
        if (!response.ok) {
          state.item.querySelector('[data-look-status]').textContent = result.description || result.message || this.labels.error;
          if (response.status === 422) { variant.available = false; state.selected = state.selected.map((v,i) => i === state.colourIndex ? v : undefined); }
          return;
        }
        confirmed = true; state.added = true;
        this.track('styled_look_add_to_cart',state,variant);
        this.close(state);
        this.querySelector('[data-look-confirmation]').textContent = state.data.title + ' — ' + this.labels.added;
        this.querySelector('.dc-look__confirmation').hidden = false;
        document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged',{bubbles:true}));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        if (window.theme?.showQuickPopup && window.jQuery) {
          const safe = document.createElement('span'); safe.textContent = this.labels.added;
          window.theme.showQuickPopup(safe.innerHTML,window.jQuery(state.trigger));
        }
        try {
          const cart = await fetch(this.dataset.cartUrl,{credentials:'same-origin',headers:{Accept:'application/json'}});
          if (cart.ok) document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart:await cart.json()}}));
        } catch (_) {}
      } catch (_) {
        if (!confirmed) { state.uncertain = true; state.item.querySelector('[data-look-status]').textContent = this.labels.uncertain; }
      } finally { state.pending = false; this.render(state); }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
